import { Instagram, Youtube, Facebook } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT, DESTINATIONS } from "@/data/content";
import { scrollToSection } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#d4af37]/15 pt-16 pb-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} />
            <p className="mt-6 text-slate-400 text-sm leading-relaxed max-w-sm">
              A UAE-based travel house crafting tailor-made tours, visit visas
              and entry permissions across eleven destinations.
            </p>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-5">Destinations</p>
            <div className="flex flex-wrap gap-x-5 gap-y-2">
              {DESTINATIONS.map((d) => (
                <button
                  key={d.name}
                  data-testid={`footer-destination-${d.name.toLowerCase().replace(/\s/g, "-")}`}
                  onClick={() => scrollToSection("#booking")}
                  className="text-sm text-slate-400 hover:text-[#d4af37] transition-colors"
                >
                  {d.name}
                </button>
              ))}
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-5">Reach Us</p>
            <div className="space-y-3 text-sm">
              <a href={`tel:${CONTACT.phoneRaw}`} data-testid="footer-phone-link" className="block text-slate-300 hover:text-[#d4af37] transition-colors">
                {CONTACT.phoneDisplay} <span className="text-slate-400 text-xs">(UAE)</span>
              </a>
              <a href={`tel:${CONTACT.phone2Raw}`} data-testid="footer-phone2-link" className="block text-slate-300 hover:text-[#d4af37] transition-colors">
                {CONTACT.phone2Display} <span className="text-slate-400 text-xs">(India)</span>
              </a>
              <a href={`tel:${CONTACT.phone3Raw}`} data-testid="footer-phone3-link" className="block text-slate-300 hover:text-[#d4af37] transition-colors">
                {CONTACT.phone3Display} <span className="text-slate-400 text-xs">(UAE)</span>
              </a>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="block text-slate-300 hover:text-[#d4af37] transition-colors break-all">
                {CONTACT.email}
              </a>
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="flex items-center gap-2 text-slate-300 hover:text-[#d4af37] transition-colors">
                <Instagram size={14} className="text-[#d4af37]" /> @rktousrismandtravel
              </a>
              <a href={CONTACT.youtube} target="_blank" rel="noreferrer" data-testid="footer-youtube-link" className="flex items-center gap-2 text-slate-300 hover:text-[#d4af37] transition-colors">
                <Youtube size={14} className="text-[#d4af37]" /> @RkTourismAndTravel
              </a>
              <a href={CONTACT.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook-link" className="flex items-center gap-2 text-slate-300 hover:text-[#d4af37] transition-colors">
                <Facebook size={14} className="text-[#d4af37]" /> RK Tourism & Travels
              </a>
              <p className="text-slate-400">{CONTACT.location}</p>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-[#d4af37]/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} RK Tourism & Travel. All rights reserved.</p>
          <p data-testid="footer-builder-credit" className="tracking-[0.1em]">
            Website builder — <span className="text-[#d4af37]">{CONTACT.builder}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
